import { useDispatch } from "react-redux";
import {
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import { Set_Truck_HeadObject_Set } from "../SliceTruck";
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
export default function GcHead({
  //grid saleshistory end
  vRdxWmsHead,
  xKey,
  xErrorMsg,
  sAttribute,
}) {
  const dispatch = useDispatch();
  return (
    <form id="TruckHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0.9 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
           marginTop={{xs:7, sm:0, md:0}}
      >
        <Grid item xs={12} sm={12} md={4}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={5} sm={3} md={6}>
              <CmpTextFieldV1
                xLabelText="TruckCode"
                xValue={vRdxWmsHead.TruckCode}
                xType={"text"} // text/number/password
                xName={"TruckCode"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      TruckCode: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.TruckCode === "" ? false : true}
                xErrorMessage={xErrorMsg.TruckCode}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={7} sm={3} md={6}>
              <CmpTextFieldV1
                xLabelText="TrackingID"
                xValue={vRdxWmsHead.TrackingID}
                xType={"text"} // text/number/password
                xName={"TrackingID"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      TrackingID: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.TrackingID === "" ? false : true}
                xErrorMessage={xErrorMsg.TrackingID}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} className="d-flex">
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="DriverName"
                xValue={vRdxWmsHead.DriverName}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      DriverName: e.target.value,
                    })
                  );
                }}
                xName={"DriverName"}
                xData={sAttribute?.Drivers}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.DriverName === "" ? false : true}
                xErrorMessage={xErrorMsg.DriverName}
                xDisable={false}
                // xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={6} md={6}>
              <CmpTextFieldV1
                xLabelText="TruckName"
                xValue={vRdxWmsHead.TruckName}
                xType={"text"} // text/number/password
                xName={"TruckName"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      TruckName: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.TruckName === "" ? false : true}
                xErrorMessage={xErrorMsg.TruckName}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <CmpDatePickerField001V1
                xLabelText="PurchaseDate"
                xtabIndex={"4"}
                xValue={vRdxWmsHead.PurchaseDate}
                xOnChange={(e) => {
                  if (
                    e?.$d == "Invalid Date" ||
                    e?.$d == null ||
                    e?.$d === undefined ||
                    e?.$d === ""
                  ) {
                    dispatch(
                      Set_Truck_HeadObject_Set({
                        ...vRdxWmsHead,
                        PurchaseDate: "",
                      })
                    );
                  } else {
                    dispatch(
                      Set_Truck_HeadObject_Set({
                        ...vRdxWmsHead,
                        PurchaseDate: e?.$d,
                      })
                    );
                  }
                }}
                xError={xErrorMsg.PurchaseDate === "" ? false : true}
                xErrorMessage={xErrorMsg.PurchaseDate}
                // xOnKeyUp={(e) => {
                //   xFocusInput("A_RefDocNo");
                // }}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <CmpCheckboxField
                xtabIndex={"107"}
                xChecked={vRdxWmsHead?.OnService === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      OnService: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"OnService"}
                xNameField={"OnService"}
                xError={xErrorMsg.OnService === "" ? false : true}
                xErrorMessage={xErrorMsg.OnService}
                sales_onvoice_check_box="start"
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <CmpCheckboxField
                xtabIndex={"107"}
                xChecked={vRdxWmsHead?.OnLease === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      OnLease: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"OnLease"}
                xNameField={"OnLease"}
                xError={xErrorMsg.OnLease === "" ? false : true}
                xErrorMessage={xErrorMsg.OnLease}
                sales_onvoice_check_box="start"
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <CmpCheckboxField
                xtabIndex={"107"}
                xChecked={vRdxWmsHead?.Sold === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      Sold: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"Sold"}
                xNameField={"Sold"}
                xError={xErrorMsg.Sold === "" ? false : true}
                xErrorMessage={xErrorMsg.Sold}
                sales_onvoice_check_box="start"
              />
            </Grid>

            <Grid item xs={6} sm={3} md={3}>
              <CmpCheckboxField
                xtabIndex={"107"}
                xChecked={vRdxWmsHead?.WMS === "Y"}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      WMS: e.target.checked ? "Y" : "N",
                    })
                  );
                }}
                xDisabled={false}
                xName={"WMS"}
                xNameField={"WMS"}
                xError={xErrorMsg.WMS === "" ? false : true}
                xErrorMessage={xErrorMsg.WMS}
                sales_onvoice_check_box="start"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <Grid
            container
            spacing={0.9}
            columnSpacing={0.5}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={3} md={4}  >
              <CmpTextFieldV1
                xLabelText="Length"
                xValue={vRdxWmsHead.Length}
                xType={"text"} // text/number/password
                xName={"Length"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      Length: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.Length === "" ? false : true}
                xErrorMessage={xErrorMsg.Length}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={4}  >
              <CmpTextFieldV1
                xLabelText="Width"
                xValue={vRdxWmsHead.Width}
                xType={"text"} // text/number/password
                xName={"Width"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      Width: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.Width === "" ? false : true}
                xErrorMessage={xErrorMsg.Width}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={4}  >
              <CmpTextFieldV1
                xLabelText="Height"
                xValue={vRdxWmsHead.Height}
                xType={"text"} // text/number/password
                xName={"Height"}
                xReadOnly={false}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      Height: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.Height === "" ? false : true}
                xErrorMessage={xErrorMsg.Height}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={3} md={4}  >
              <CmpTextFieldV1
                xLabelText="CBM"
                xValue={vRdxWmsHead.CBM}
                xType={"text"} // text/number/password
                xName={"CBM"}
                xReadOnly={true}
                xOnChange={(e) => {
                  dispatch(
                    Set_Truck_HeadObject_Set({
                      ...vRdxWmsHead,
                      CBM: e.target.value,
                    })
                  );
                }}
                xError={xErrorMsg.CBM === "" ? false : true}
                xErrorMessage={xErrorMsg.CBM}
                xOnKeyUp={xKey}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    
    </form>
  );
}
